export { default } from "./HeaderWorkspace-component";
